import { IconButton, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import { useUiStore } from "hooks/useUiStore";

export const DarkMode = () => {
  const theme = useTheme();
  const { darkMode, handleChangeDarkMode } = useUiStore();

  const colorMode = () => {
    localStorage.setItem("typeTheme", darkMode === "light" ? "dark" : "light");
    handleChangeDarkMode(darkMode === "light" ? "dark" : "light");
  };

  return (
    <Tooltip title={darkMode === "dark" ? "Modo Claro" : "Modo Oscuro"}>
      <IconButton sx={{ ml: 1 }} onClick={colorMode} color="inherit">
        {theme.palette.mode === "dark" ? (
          <Brightness4Icon />
        ) : (
          <Brightness7Icon />
        )}
      </IconButton>
    </Tooltip>
  );
};
